"use client";

import React from "react";
import styles from "./VideoBlok.module.css";
import dynamic from "next/dynamic";
import type { BlokProps } from "@frend-digital/storyblok";
import type { BlokVideo } from "@/storyblok";

const ReactPlayer = dynamic(() => import("react-player/lazy"));

export const VideoBlok = ({ blok }: BlokProps<BlokVideo>) => {
	if (!blok.url) return null;

	return (
		<div className={styles.root}>
			<ReactPlayer url={blok.url} width="100%" height="100%" />
		</div>
	);
};
